export default __webpack_public_path__ + "static/media/deals.c0bc0a60.svg";